import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

import { getGeoTiffResolution } from '../../../api/Layers/layer-operations';
import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';

const LayerGeoTiffResolutionField = ({ layerSubType, layer }) => {
  if (LAYER_SUBTYPES.GEOTIFF === layerSubType) {
    return (
      <Form.Group>
        <Form.Label>Resolution</Form.Label>
        <Form.Control
          type="Number"
          name="geoTiffResolution"
          defaultValue={getGeoTiffResolution(layer)}
          placeholder="Resolution for the GeoTiff layer"
        />
      </Form.Group>
    );
  }
  return '';
};
LayerGeoTiffResolutionField.propTypes = {
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired
};

export default LayerGeoTiffResolutionField;
